import React, {useState, useEffect} from 'react';
import {useHistory} from 'react-router-dom';
import './Login.sass';
import LoginJsx from './Login.jsx';

import axios from 'axios';

function Login() {

  const [username, setUsername] = useState('');
  const [usernameTouched, setUsernameTouched] = useState(false);
  const [password, setPassword] = useState('');
  const [passwordTouched, setPasswordTouched] = useState(false);
  const [authErr, setAuthErr] = useState('');
  const [loginErr, setLoginErr] = useState('');
  const [fadedLeft, setFadedLeft] = useState(true)
  const [fadedRight, setFadedRight] = useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();

  useEffect(() => {
    setFadedLeft(true);
    setTimeout(function () {
    setFadedLeft(false)
  }, 100);
  }, [])

  const handleSubmit = (e) => {
    e.preventDefault();
    let tfakey = localStorage.getItem('2FAkey')
    let data = {
      username: username,
      password: password,
      key: tfakey ? tfakey : undefined
    }
    setIsLoading(true);
    axios.post(`${process.env.REACT_APP_API_ENDPOINT}/login`, data)
      .then(res => {
        console.log(res);
        if(res.data.token) {
          let timestamp = Date.now();
          localStorage.setItem('jwt', res.data.token);
          localStorage.setItem('timestamp', timestamp);
        }
        setIsLoading(false);
        if(res.status === 200) {
          setFadedRight(true);
          setTimeout(function () {
            if(res.data.token && !res.data.key) {
              history.push(`/dashboard`);
            } else if (res.data.key && !res.data.token) {
              localStorage.setItem('2FAkey', '');
              history.push(`/verify/${res.data.key}`);
            }
          }, 500);
        }
      }).catch(err => {
        setIsLoading(false);
        // console.log(err.response.data.error_message)
        setLoginErr(err?.response?.data?.error_message)
      })
  }

  const setFormValues = (e) => {
    if (e.target.id === 'loginEmail') {
      setUsername(e.target.value);
      setUsernameTouched(true);
    }
    if (e.target.id === 'loginPassword') {
      setPassword(e.target.value);
      setPasswordTouched(true);
    }
  }

  useEffect(() => {
    checkAuth()
  }, [])

  useEffect(() => {
    validateForm();
  }, [setFormValues]);

  const validateForm = () => {
    setAuthErr('')
    if(!username && usernameTouched) {
      setAuthErr('User is required')
    }
    if(!password && passwordTouched) {
      setAuthErr('Password is required')
    }
  }

  const checkAuth = () => {
    let key = localStorage.getItem('jwt');
    let timestamp = localStorage.getItem('timestamp');
    let currentTime = Date.now();
    let timeLimit = parseInt(timestamp) + 12 * 60 * 60
    if (timestamp && key && timeLimit < currentTime) {
        history.push(`/dashboard`);
      }
    }

  return(
    <div>
      <LoginJsx
      handleSubmit={handleSubmit}
      setFormValues={setFormValues}
      isLoading={isLoading}
      authErr={authErr}
      loginErr={loginErr}
      fadedLeft={fadedLeft}
      fadedRight={fadedRight}/>
    </div>
  )
}

export default Login;
